module.exports = "https://ec-cstatic.akulaku.net/mall/mobile/_next/static/images/network_error-a429294ba86368eeb0c9c2636b5b30bf.png";